import type { CreateInvoicePaymentMode } from "./types"

/**
 * Whether a payment mode lets the rep restrict the customer's payment
 * methods. Mirrors the backend's `PAYMENT_METHOD_SELECTABLE_MODES`.
 *
 * Installments capture their card off-session through a setup-mode
 * session pinned to `["card"]` and the charge engine is card-only; the
 * on-call channel charges a card on the call. Neither has a choice to
 * offer, and the API rejects the field for them.
 *
 * Named once because the rule was previously spelled positively in the
 * two form components (`mode === "full" || mode === "deposit"`) and
 * negatively in four places in the mappers — a fourth payment mode would
 * have been silently included by one spelling and excluded by the other.
 */
export function supportsPaymentMethodChoice(
  mode: CreateInvoicePaymentMode,
): boolean {
  return mode === "full" || mode === "deposit"
}
